import { render, staticRenderFns } from "./IconPadlock.vue?vue&type=template&id=947ebc34"
import script from "./IconPadlock.vue?vue&type=script&lang=ts"
export * from "./IconPadlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports